/**
 * @generated SignedSource<<dd5d3750be252a2cfa9473972a4bfa14>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type usePartialItems_item$data = ReadonlyArray<{
  readonly isPartialItem: boolean | null;
  readonly personalizationType: string | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "usePartialItems_item";
}>;
export type usePartialItems_item$key = ReadonlyArray<{
  readonly " $data"?: usePartialItems_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePartialItems_item">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "usePartialItems_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPartialItem",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "personalizationType",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "6100f12a0e668629c0ba58e1e48f7efd";

export default node;
